import React, {
  FC, PropsWithChildren, useMemo,
} from 'react';

import { ISurfaceCustomProps } from './types';
import { usePaddingBlockStyles, usePaddingInlineStyles, useRadiusStyles } from './styles';
import { SurfaceBase } from '../surface-base';

export const SurfaceCustom: FC<PropsWithChildren<ISurfaceCustomProps>> = (props: ISurfaceCustomProps) => {
  const {
    appearance,
    children,
    paddingInline,
    paddingBlock,
    radius,
  } = props;

  const radiusStyles = useRadiusStyles();
  const paddingBlockStyles = usePaddingBlockStyles();
  const paddingInlineStyles = usePaddingInlineStyles();

  const classNames = useMemo(() => {
    const c = [];
    if (radius) c.push(radiusStyles[radius]);
    if (paddingBlock) c.push(paddingBlockStyles[paddingBlock]);
    if (paddingInline) c.push(paddingInlineStyles[paddingInline]);
    return c;
  }, [paddingBlock, paddingBlockStyles, paddingInline, paddingInlineStyles, radius, radiusStyles]);

  return (
    <SurfaceBase
      appearance={appearance}
      classNames={classNames}
    >
      {children && children}
    </SurfaceBase>
  );
};

// Export SurfaceCustom component
SurfaceCustom.displayName = 'SurfaceCustom';
